import * as Yup from "yup";
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
import { toast } from "react-toastify";

import api from "services/api";

async function requestGetAccessToken(): Promise<string> {
  const req = axios.create({
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Accept-Language": "pt-BR",
      client_id: process.env.REACT_APP_CLIENT_ID,
    },
    baseURL: process.env.REACT_APP_API_URL_OAUTH,
  });

  const header = {
    "Content-Type": "application/json",
    "Accept-Language": "pt-BR",
    Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
  };
  const parameters = {
    method: "POST",
    headers: header,
  };
  const body = {
    grant_type: "client_credentials",
  };

  let access_token = "";

  access_token = localStorage.getItem("@UltragazEmpresarial:accessToken") || "";

  if (access_token) {
    return access_token;
  }

  try {
    const response = await req.post("oauth/access-token", body, parameters);
    access_token = response.data.access_token;
  } catch (error: any) {
    const erro = error.response;
    if (erro) {
      const { message } = error.response.data;
      if (error.response.status !== 401) {
        toast.error(message);
      }
    } else if (error.response.status !== 401) {
      toast.error("Ocorreu um erro interno na aplicação");
    }
  }

  return access_token;
}

export async function requestGetCondominiusByZipCode(
  zipcode: string
): Promise<unknown> {
  if (!zipcode) return undefined;
  const access_token = await requestGetAccessToken();

  const headers = {
    access_token,
  };
  const params = {
    "zip-code": zipcode,
  };

  try {
    const response = await api.get("industrial/customer/v1/condominiums", {
      params,
      headers,
    });
    return response;
  } catch (error: any) {
    const erro = error.response;
    if (erro) {
      const { message } = error.response.data;
      if (error.response.status !== 401) {
        toast.error(message || "Ocorreu um erro interno na aplicação");
      }
    } else if (error.response.status !== 401) {
      toast.error("Ocorreu um erro interno na aplicação");
    }
  }
  return undefined;
}

export async function requestGetCondominiusByCode(
  code: string,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  type = "code",
  setShowCondoUnavailableModal?: (v: boolean) => void
): Promise<unknown> {
  const access_token = await requestGetAccessToken();
  const headers = {
    access_token,
  };
  try {
    const document = localStorage.getItem("@UltragazEmpresarial:document");
    const response = await api.get(
      `industrial/customer/v1/condominiums/${code}?document=${document}`,
      { headers }
    );
    const { data } = response;
    if (!data.blocks.length) {
      toast.error("Um erro inesperado aconteceu. Tente novamente mais tarde.");
      return undefined;
    }
    return data;
  } catch (error: any) {
    const erro = error.response;
    if (erro) {
      const { message } = error.response.data;
      if (error.response.status !== 401) {
        if (error.response.data && error.response.data.code === "422.023") {
          setShowCondoUnavailableModal?.(true);
        } else {
          toast.error(message);
        }
      }
    } else if (error.response.status !== 401) {
      toast.error("Ocorreu um erro interno na aplicação");
    }
  }
  return undefined;
}

export function validatorSchema(): Yup.AnyObjectSchema {
  return Yup.object().shape({
    typeSelector: Yup.string(),
    cep: Yup.string().when("typeSelector", {
      is: (val: string) => val === "cep",
      then: Yup.string()
        .matches(/[0-9]{5}-[0-9]{3}/, "Cep inválido")
        .required("É necessário digitar o CEP"),
      otherwise: Yup.string(),
    }),
    code: Yup.string().when("typeSelector", {
      is: (val: string) => val === "code",
      then: Yup.string().required(
        "É necessário digitar o código do condomínio"
      ),
      otherwise: Yup.string(),
    }),
    blockIdSf: Yup.string().when("typeSelector", {
      is: (val: string) => val === "code",
      then: Yup.string().required("É necessário selecionar um bloco"),
    }),
    unit: Yup.string().when("typeSelector", {
      is: (val: string) => val === "code",
      then: Yup.string().required("É necessário selecionar uma unidade"),
      otherwise: Yup.string(),
    }),
    blockIdSfCep: Yup.string().when("typeSelector", {
      is: (val: string) => val === "cep",
      then: Yup.string().required("É necessário selecionar um bloco"),
    }),
    unitCep: Yup.string().when("typeSelector", {
      is: (val: string) => val === "cep",
      then: Yup.string().required("É necessário selecionar uma unidade"),
      otherwise: Yup.string(),
    }),
  });
}
